export const TMP_ELEMENT_POSITION = { x: 0, y: 0 };
export const TMP_ELEMENT_SIZE = { width: 250, height: 50 };

/*
 * Base class for all Box shapes.
 * Concrete subclasses need to provide the following attributes:
 *  - labelText
 *  - labelFill
 *  - labelWidth
 * 
 */
export function AbstractBoxConstructor(services, callbacks, context, siteTypeConfig) {

  const DEFAULT_BOX_WIDTH = 250;
  const DEFAULT_BOX_HEIGHT = 86;

  const joint = services.joint;

  return joint.shapes.devs.Model.extend({
    'markup': '<g class="rotatable"><rect class="root-label"/><text/><rect class="body"/></g>',
    'portLabelMarkup': '',
    'defaults': joint.util.deepSupplement({
      'isBoxType': true,
      'isBoxValid': true,

      //  Box dropdown btns
      'canBeDuplicated': true,
      'canBeTested': siteTypeConfig.boxesCanBeTested,
      'canBeDeleted': true,

      'z': 10,
      'size': {
        'width': DEFAULT_BOX_WIDTH,
        'height': DEFAULT_BOX_HEIGHT
      },
      'attrs': {
        '.body': {
          'stroke': 'none',
          'stroke-width': 1,
          'fill-opacity': 0
        },
        'text': {
          'fill': '#fff',
          'font-size': 12,
          'font-weight': 'bold',
          'refX': 0.1,
          'refY': 0.5,
          'ref': '.root-label',
          'y-alignment': 'middle',
          'x-alignment': 'left'
        },
        '.root-label': {
          'stroke': 'none',
          'fill-opacity': 0.9,
          'follow-scale': true,
          'height': 28,
          'refX': 0,
          'refY': -28,
          'ref': '.body'
        }
      }
    }, joint.shapes.devs.Model.prototype.defaults),

    // called by joint.shapes.html.AbstractElementView.initialize()
    updateLabel: function (showIds = false) {
      const attrs = {
        'text': {
          'text': showIds ? `(${this.get('id')}) ${this.get('labelText')}` : this.get('labelText')
        },
        '.root-label': {
          'fill': this.get('labelFill'),
          'width': DEFAULT_BOX_WIDTH
        }
      }
      this.attr(attrs);
    },

    isBoxValid: function () {
      return this.get('isBoxValid');
    },

    setBoxValid: function (valid) {
      this.set('isBoxValid', valid);
    },

    updateValidityInUI: function () {
      const isValid = this.isBoxValid();
      const attrs = {
        '.body': {
          'stroke': isValid ? 'none' : '#ff0000'
        },
        '.root-label': {
          'fill': isValid ? this.get('labelFill') : '#ff0000'
        }
      }
      this.attr(attrs);
    },

    isLinkTarget: function () {
      let isTarget = false;
      this.graph.getLinks().forEach(link => {
        const target = link.get('target');
        if (target && target.id && target.id === this.get('id')) {
          isTarget = true;
        }
      });
      return isTarget;
    }
  });
}

export function AbstractBoxWithInPortConstructor(services, callbacks, context, siteTypeConfig) {

  const joint = services.joint;

  return joint.shapes.html.AbstractBox.extend({
    'defaults': joint.util.deepSupplement({
      'inPorts': ['in'],
      'ports': {
        'groups': {
          'in': {
            'position': {
              'name': 'absolute',
              'args': {
                'y': -14
              }
            },
            'attrs': {
              '.port-body': {
                'fill': '#fff',
                'magnet': 'passive',
                'stroke-width': '3'
              }
            }
          },
        }
      },
    }, joint.shapes.html.AbstractBox.prototype.defaults)
  });
}
